import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";

export class WalletIcon extends React.Component<ISvgIconProps> {

    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 24 24" >
                <path d="M22.433 10.463V8.083c0 -1.24 -1.053 -2.249 -2.348 -2.249h-3.029L11.996 1.523a0.8 0.8 0 0 0 -1.04 0L5.896 5.833H3.912c-2.159 0 -3.913 1.683 -3.913 3.749v9c0 2.068 1.755 3.751 3.913 3.751h16.173c1.293 0 2.347 -1.009 2.347 -2.251v-2.379c0.912 -0.309 1.567 -1.143 1.567 -2.121v-3c0 -0.977 -0.653 -1.811 -1.565 -2.12M11.477 3.087l3.224 2.747H8.252z
                        m9.391 16.996c0 0.413 -0.351 0.751 -0.783 0.751H3.912c-1.295 0 -2.348 -1.011 -2.348 -2.251v-9c0 -1.24 1.053 -2.249 2.347 -2.249h16.173c0.432 0 0.784 0.336 0.784 0.749v2.249H18.52c-2.159 0 -3.913 1.683 -3.913 3.751 0 2.067 1.755 3.751 3.913 3.751h2.347z
                        m1.565 -4.499c0 0.413 -0.352 0.749 -0.783 0.749H18.52c-1.293 0 -2.347 -1.009 -2.347 -2.249s1.053 -2.251 2.347 -2.251h3.131c0.431 0 0.783 0.337 0.783 0.749z
                        M18.52 13.333a0.767 0.767 0 0 0 -0.783 0.751c0 0.413 0.351 0.749 0.783 0.749a0.767 0.767 0 0 0 0.783 -0.749 0.767 0.767 0 0 0 -0.783 -0.751"
                    fill="currentColor"
                />
           </SvgIcon>
        )
    }
}